import $ from 'jquery';
import React from 'react';
import { string, shape } from 'prop-types';
import Icon from 'components/icon';

export default function PeopleTile({ item, btnText }) {
    const portrait = imgSrc => {
        const img = new Image();
        img.src = imgSrc;
        if (img.complete) {
            if (img.naturalWidth < img.naturalHeight) {
                $(`img[src="${imgSrc}"]`).parent().addClass('portrait');
            } else {
                $(`img[src="${imgSrc}"]`).parent().removeClass('portrait');
            }
        } else {
            img.onload = () => {
                if (img.naturalWidth < img.naturalHeight) {
                    $(`img[src="${imgSrc}"]`).parent().addClass('portrait');
                } else {
                    $(`img[src="${imgSrc}"]`).parent().removeClass('portrait');
                }
            };
        }
    };

    return (
        <div className="c-tile c-people-tile">
            <div className="tile-image">
                <img src={item.thumbnail} alt={item.title} />
                {portrait(item.thumbnail)}
            </div>
            <h4><a href={item.url}>{item.title}</a></h4>
            <p className="position">{item.position}
                {item.positionInfo && (
                    <span>
                        <br />
                        {item.positionInfo}
                    </span>
                )}
            </p>
            <p className="location">{item.location}</p>
            <div className="contact-links">
                {item.phone &&
                    <a href={`tel:${item.phone}`}>
                        <span>phone</span>
                        <Icon glyph="phone" />
                    </a>
                }
                {item.email &&
                    <a href={`mailto:${item.email}`}>
                        <span>email</span>
                        <Icon glyph="email" />
                    </a>
                }
                {item.linkedIn &&
                    <a href={item.linkedIn} target="_blank">
                        <span>linkedIn</span>
                        <Icon glyph="linkedin" />
                    </a>
                }
            </div>
            <a className="btn btn-skin-2 btn-small" href={item.url}>{btnText}</a>
        </div>
    );
}

PeopleTile.defaultProps = { btnText: 'More info' };
PeopleTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        thumbnail: string.isRequired,
        title: string.isRequired,
        position: string.isRequired,
        positionInfo: string.isRequired,
        location: string.isRequired,
        phone: string,
        email: string,
        linkedIn: string,
        url: string.isRequired
    }).isRequired,
    btnText: string
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/PeopleTile.jsx